module.exports = __webpack_public_path__ + "img/i-phone-xs-max.0a9fba7e.svg";